import {BootstrapButton, BootstrapModal} from '../react-bootstrap'
import update from 'react-addons-update'
import {pick, renderErrors2, getImageUrlForProduct, scrollToErrors} from '../utils'

var minOrderAmount = 50;

export class Cart extends React.Component {
    constructor(props) {
        super(props);

        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
        this.onClearCart = this.onClearCart.bind(this);
        this.onCheckout = this.onCheckout.bind(this);
        this.validate = this.validate.bind(this);

        this.state = {calculator: this.props.calculator, items: this.props.calculator.items};
    }

    handleCancel () {
        this.refs.modal.close();
    }
    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }
    onQuantityChange(event, i) {
        var quantity = event.target.value;
        if (!quantity) quantity = null;
        else quantity = parseInt(quantity);
        if (isNaN(quantity) || quantity < 0) return;
        this.setState({items: update(this.state.items, {[i]: {quantity: {$set: quantity}}})});
    }
    postJSON(url, data) {
        return $.postJSON(url, data).done(data => {
            this.setState({calculator: data.calculator, items: data.calculator.items}, this.validate);
        }).fail((xhr, textStatus, errorThrown) => {
            this.setState({errors: ['Operation failed.']}, scrollToErrors);
        });
    }
    onQuantityBlur(event, i) {
        var item = this.state.items[i];
        this.postJSON('/cart/change_quantity', pick(item, 'sku', 'quantity'));
    }
    onEditNotes(event, i) {
        event.preventDefault();
        var item = this.state.items[i];
        var el = event.target;
        if (item.notes == null) {
            item.notes = '';
            this.forceUpdate(() => $(el).closest('td').find('input').focus());
        }
    }
    onRemoveNotes(event, i) {
        event.preventDefault();
        var item = this.state.items[i];
        item.notes = '';
        this.onNotesBlur(null, i);
    }
    onNotesBlur(event, i) {
        var item = this.state.items[i];
        $.postJSON('/cart/change_item_notes', pick(item, 'sku', 'notes')).fail((xhr, textStatus, errorThrown) => {
            if (item.notes == null) item.notes = '';
            item.saveNotesError = 'Saving notes failed.';
            this.forceUpdate();
        }).done(() => {
            if (!item.notes || !item.notes.trim()) item.notes = null;
            delete item.saveNotesError;
            this.forceUpdate();
        });
    }
    onDeleteItem(event, i) {
        event.preventDefault();
        var item = this.state.items[i];
        this.postJSON('/cart/remove_item', {sku: item.sku});
    }
    onClearCart(event) {
        event.preventDefault();
        this.postJSON('/cart/clear');
    }
    validate() {
        var errors = [];

        var inactiveProducts = this.state.items.filter(item => !item.is_active);
        var outOfStockProducts = this.state.items.filter(item => item.stock <= 0);
        if (inactiveProducts.length > 0 || outOfStockProducts.length > 0) {
            var desc = inactiveProducts.length > 0 && outOfStockProducts.length > 0 ? 'inactive and out of stock products' : inactiveProducts.length > 0 ? 'inactive products' : 'out of stock products';
            errors.push('Please delete ' + desc + '.');
        }

        var lessThanMOQ = this.state.items.filter(item => item.quantity && item.quantity < item.moq);
        errors = errors.concat(lessThanMOQ.map(item => item.sku + ': Enter a quantity equal to or greater than MOQ(Minimum Order Quantity).'));

        if (!this.meetMinOrderAmount()) {
            errors.push('The minimum order amount is $' + minOrderAmount + '.');
        }
        this.setState({errors: errors.length > 0 ? errors : null}, scrollToErrors);
        return !errors.length;
    }
    onCheckout(event) {
        if (this.validate()) window.location = '/checkout';
    }
    meetMinOrderAmount() {
        return this.state.calculator.discounted_subtotal >= minOrderAmount;
    }
    render () {
        var items = this.state.items;
        //var totalQuantities = items.reduce((prev, curr) => prev + curr.quantity, 0);

        return (
            <div>
                <h3>Cart</h3>
                <hr />
                {
                    items.length === 0 ?
                        <p>Your cart is currently empty.</p>
                        :
                        <div>
                            { renderErrors2(this.state.errors, '_overall_') }
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Item No.</th>
                                        <th>Image</th>
                                        <th>Product Name</th>
                                        <th>Unit Price</th>
                                        <th>MOQ</th>
                                        <th>Quantity</th>
                                        <th>Discount</th>
                                        <th className="last">Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        items.map((item, i) => (
                                            <tr key={ item.sku } className={item.is_active && item.stock > 0 ? '': 'inactive'}>
                                                <td>{ item.sku }</td>
                                                <td>{ getImageUrlForProduct(item) ? <img src={getImageUrlForProduct(item, 'sm')} /> : null }</td>
                                                <td>{ item.name }
                                                    {
                                                        item.attributes && (item.attributes.color || item.attributes.size) ?
                                                            <div>
                                                                {item.attributes.color ? <span style={{ marginRight: '1.5em'}}>Color: {item.attributes.color}</span> : null}
                                                                {item.attributes.size ? <span>Size: {item.attributes.size}</span> : null}
                                                            </div>
                                                            : null
                                                    }
                                                    <div>
                                                        <a href="#" onClick={event => this.onDeleteItem(event, i)}>Remove</a> &nbsp;
                                                        <a href="#" onClick={event => this.onEditNotes(event, i)} style={{color: item.notes != null ? 'red' : '' }}>Notes</a>
                                                    </div>
                                                    { item.notes != null ?
                                                        <div style={{'whiteSpace': 'nowrap'}}>
                                                            <input type="text" className="form-control form-control-sm" maxLength="100" style={{display: 'inline-block', 'minWidth': '10em', width: 'auto', 'marginRight': '0.4em' }} value={item.notes == null ? '' : item.notes} onChange={event => { item.notes = event.target.value; this.forceUpdate();}} onBlur={event => this.onNotesBlur(event, i)} />
                                                            <a href="#" className="glyphicon glyphicon-remove" style={{color: '#aaa', 'textDecoration': 'none'}} onClick={event => this.onRemoveNotes(event, i)}></a>
                                                        </div>
                                                            : null
                                                    }
                                                    { item.saveNotesError ?
                                                        <div className="text-danger">{ item.saveNotesError }</div>
                                                            : null
                                                    }
                                                </td>
                                                <td>${ item.unit_price }
                                                    { !item.is_active ? <div style={{color: 'red'}}>Inactive</div> : null }
                                                    { item.stock <= 0 ? <div style={{color: 'red'}}>Out of Stock</div> : null }
                                                </td>
                                                <td>{ item.moq }</td>
                                                <td><input className="form-control form-control-sm" value={ item.quantity == null ? '' : item.quantity } onChange={event => this.onQuantityChange(event, i)} onBlur={event => this.onQuantityBlur(event, i)} />
                                                </td>
                                                <td>${item.line_discount}</td>
                                                <td className="last">${ item.line_price }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    <tr key="_">
                                        <td>
                                            <a href="#" onClick={this.onClearCart}>Clear cart</a></td>
                                        <td className="subtotal" colSpan="7" style={{height: '4em'}}>
                                            <dl className="dl-horizontal">
                                                <dt>Subtotal:</dt>
                                                <dd><span className="price">${this.state.calculator.discounted_subtotal}</span></dd>
                                            </dl>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <p className="checkout-p"><button onClick={this.onCheckout} className="btn btn-warning btn-lg">Proceed to Checkout <span className="glyphicon glyphicon-arrow-right"></span></button></p>
                        </div>
                }
            </div>
        );
    }
}
